// 接口请求基本配置
// 日志插件
// import * as MITO from '@zyf2e/monitor-web'
// import { cacheAdapterEnhancer } from 'axios-extensions'
// import LRUCache from 'lru-cache'
import dayjs from 'dayjs' // 时间转换
import md5 from 'md5'
import apiConfig from '~/assets/js/api/index'
import { setApiCache, getCacheDataByKey } from '~/assets/js/api/methods'

const tokenURL = process.env.NODE_ENV == 'production' ? 'https://wikidatacenter.interface003.com:32377' : 'https://wikidatacenter.interface003.com:32377'

// 需要返回完整结果的接口(res.data)
const needReturnFullResult = ['/market/platform/add', '/market/payment/add', '/market/licenseCommission/add', '/market/licenseTransfer/add', '/market/exhibition/add', '/market/ib/add', '/market/personal/add', '/market/team/add', '/market/ea/add', '/market/rumor/add', '/market/quotation/add', '/market/technical/add']

export default ({ $axios, store, $cookies, app, req, $winstonLog, error, ssrContext, route }, inject) => {
  // ---------- 处理请求拦截的准备工作（开始） ----------
  let isRefreshing = false // 是否正在刷新
  const requests = [] // 存储请求的数组
  // 挂起请求
  function subscribeTokenRefresh(cb) {
    requests.push(cb)
  }
  // 执行挂起的请求（数组中的请求得到新的token之后自执行，用新的token去请求数据）
  function onRrefreshed(token) {
    requests.map((cb) => cb(token))
  }
  // ---------- 处理请求拦截的准备工作（结束） ----------

  // 接口报错，容错处理
  const errorHandler = (err = {}) => {
    if ($axios.isCancel(err)) {
      // console.log('error.message', err.message)
      return Promise.resolve(err.message)
    }
    console.log('err111: ', 11, err?.request?.path, 22, err?.message, 33, err?.status, 44, new Date())
    // if (process.env.NODE_ENV == 'development') return
    // err.config.headers.metadata.endtime = new Date().getTime()
    const ip = store.state.userIp
    const pageurl = store.state.allHost
    if (err.response && err.response.status == 401) $cookies.removeAll()
    const time = err.config.headers.metadata ? err.config.headers.metadata.starttime : new Date().getTime()
    const timer = new Date().getTime() - time

    let params = JSON.stringify(err.config.params)
    if (!params) {
      if (err.config && err.config.method && err.config.method.toLowerCase() == 'post') {
        if (err.config.data && err.config.data.base64) {
          err.config.data.base64 = '图片base64格式内容(被替换)'
        } else if (err.config.data && err.config.data.images && err.config.data.images.length > 0 && err.config.data.images[0] && err.config.data.images[0].base64) {
          err.config.data.images.forEach((el) => {
            el.base64 = '图片base64格式内容(被替换)'
          })
        }
        params = JSON.stringify(err.config.data)
      }
    }
    params = decodeURIComponent(params)

    let headers = ''
    if (err.config && err.config.headers) {
      headers = JSON.stringify(err.config.headers)
    }
    if (!headers && req && req.headers) {
      headers = JSON.stringify(req.headers)
    }
    headers = decodeURIComponent(headers)

    const interfaceurl = err.config && err.config.url ? err.config.url : ''
    const interfacemethod = err.config && err.config.method ? err.config.method : ''
    const interfacestatus = err.response && err.response.status ? err.response.status : ''
    const lan = err.config && err.config.headers && err.config.headers.LanguageCode ? err.config.headers.LanguageCode : ''
    const contry = err.config && err.config.headers && err.config.headers.CountryCode ? err.config.headers.CountryCode : ''
    const BasicData = err.config && err.config.headers && err.config.headers.BasicData
    let response = ''
    if (typeof err.response == 'object') {
      response = err.response ? JSON.stringify(err.response) : ''
    } else {
      response = err.response ? err.response : ''
    }

    if ($winstonLog) {
      // 服务端接口报错，存入本地
      const mttime = dayjs()
      const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.sss')} ERROR [DATA-API-WEB]:{"Function":"asyncData中的axios异常","Url":"${interfaceurl}","pageurl":"${pageurl}","ip":"${ip}","HttpType":"${interfacemethod}","HttpState":${interfacestatus},"Time":${timer},"Parameter":${params},"Headers":${headers},"返回":"${response}","Message":"${err.message}","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
      if (!msg.includes('/api/log')) {
        $winstonLog.error(msg)
      }
    } else {
      try {
        const mttime = dayjs()
        const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.SSS')} ERROR [DATA-API-WEB]:{"Function":"JS中的axios异常","Url":"${interfaceurl}","pageurl":"${pageurl}","ip":"${ip}","CountryCode":"${contry}","LanguageCode":"${lan}","BasicData":"${BasicData}","HttpType":"${interfacemethod}","HttpState":${interfacestatus},"Time":${timer},"Parameter":${params},"Headers":${headers},"返回":"${response}","Message":"${err.message}","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
        if (!msg.includes('/api/log')) {
          this.$fxlog(msg, err.config.url, store.state.LanguageCode, '1', 'ERROR')
        }
      } catch (err) {}
    }
    return Promise.reject(error)
  }
  // 创建axios请求
  // const aget = (req && req.headers['user-agent']) ? req.headers['user-agent'] : ''
  // const browsertype = aget.includes('Chrome') || aget.includes('Safari') || aget.includes('Firefox')
  // if (browsertype) {
  //   const { cacheAdapterEnhancer } = require('axios-extensions')
  //   const LRUCache = require('lru-cache')
  //   const defaultAdapter = $axios.defaults.adapter
  //   const cacheCfg = new LRUCache({ maxAge: 1000 * 1800, max: 1000 })
  //   $axios.defaults.adapter = cacheAdapterEnhancer(defaultAdapter, { enabledByDefault: false, cacheFlag: 'useCache', defaultCache: cacheCfg })
  // }
  const request = $axios.create({
    baseURL: '',
    timeout: process.env.NODE_ENV == 'production' ? 15000 : 15000
  })

  // 请求拦截
  request.interceptors.request.use(async (config) => {
    // 服务端请求
    // config.metadata.starttime = new Date().getTime()
    // console.log(store.state.LanguageCode, 886)
    const bfp = $cookies.get('wiki-bfp') ? $cookies.get('wiki-bfp') : '822ca7b3261a0b2ec10c8cdabfb5a0ea'
    // const base = (store.state.isWiki == '1' || store.state.isWiki == '3') ? `999,0,2,999,0,${bfp},0` : `999,0,1,225,1,${bfp},0`
    // const base = store.state.isWiki == '1' ? `999,0,2,999,0,${bfp},0` : ((store.state.isWiki == '2' || store.state.isWiki == '4') ? `999,0,1,225,1,${bfp},0` : ((store.state.myCountry == 'cn' ? `999,0,1,225,1,${bfp},0` : `999,0,2,999,0,${bfp},0`)))
    let base = `999,0,2,999,0,${bfp},0`
    let basehash = '999,0,2,999,0,0'
    if (store.state.isWiki == '1') {
      base = `999,0,2,999,0,${bfp},0`
      basehash = '999,0,2,999,0,0'
    } else if (store.state.myCountry == 'cn') {
      base = `999,0,1,999,1,${bfp},1`
      basehash = '999,0,1,999,1,1'
    } else {
      base = `999,0,2,999,0,${bfp},0`
      basehash = '999,0,2,999,0,0'
    }
    // lang-information-id  列表页
    // lang-discover-id 详情页
    if (route?.query?.marketingActivity && route?.query?.marketingParam && !process.server) {
      localStorage?.setItem('querymarket', '1')
    }
    const wikitag = route?.name == 'lang-information-id' ? `${route?.query?.marketingActivity},${route?.query?.marketingParam},1` : route?.name == 'lang-discover-id' ? `${route?.query?.marketingActivity},${route?.query?.marketingParam},2` : ''
    Object.assign(config.headers, {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      CountryCode: route?.name == 'lang-thskyline.html' ? 'th' : store.state.CountryCode, // skyline独立页面特殊处理
      'x-forword-for': store.state.userIp,
      LanguageCode: store.state.LanguageCode,
      BasicData: base,
      basehash,
      wsc: 2,
      ENVIRONMENT: store.state.nodeEnv,
      metadata: {
        starttime: new Date().getTime()
      },
      Scenecode: `${base}_${md5(route?.fullPath)}_${store.state.nowtime}`,
      wikitag: !process.server && localStorage?.getItem('querymarket') == '1' ? wikitag : ''
    })
    const [now, cookieTime] = [Date.parse(new Date()), $cookies.get('expiresIn')] // 获取当前时间戳和token有效时长
    if (process.server) {
      const result = getCacheDataByKey(ssrContext.$cache, config)
      if (typeof result !== 'boolean') {
        const source = $axios.CancelToken.source()
        config.cancelToken = source.token
        // 请求取消并且返回缓存里面的值
        source.cancel(result)
        return config
      }
    }
    if (process.server) return config
    // 客户端请求
    const au = `fx${store.state.userIp.split('.').join('')}`
    const token = $cookies.get(au)
    // console.log(token, now < cookieTime, 444)
    if (token && now < cookieTime) {
      // 存在token且尚未失效时
      config.headers.Authorization = `Bearer ${token}`
      return config
    } else {
      // 不存在token时
      if (!isRefreshing) {
        isRefreshing = true // 正在刷新中
        const authorizeData = await $axios.post(`${tokenURL}/oauth2/authorize`, {
          // 1. 获取授权码
          response_type: 'code',
          scope: 'email address',
          client_id: 'YWdncmVnYXRpb24tYXV0aGVudGljYXRpb24taWQ=',
          provision_key: 'wiki-aggregation-layer-key',
          authenticated_userid: 'authenticated_tester'
        })
        // isRefreshing = true // 正在刷新中
        const tokenData = await $axios.post(`${tokenURL}/oauth2/token`, {
          // 2. 获取访问码
          grant_type: 'authorization_code',
          client_id: 'YWdncmVnYXRpb24tYXV0aGVudGljYXRpb24taWQ=',
          client_secret: 'YWdncmVnYXRpb24tYXV0aGVudGljYXRpb24tc2VjcmV0',
          code: authorizeData.data.redirect_uri.split('=')[1]
        })
        isRefreshing = false
        const { access_token: ntoken = '', expires_in: expiresIn = '' } = tokenData.data || {}
        // console.log(ntoken, 88812)
        const in1hour = expiresIn * 1000 + Date.parse(new Date()) // 有效时长
        $cookies.set(au, ntoken, {
          maxAge: 600,
          domain: store.state.cookieHost,
          path: '/'
        }) // 存储token
        $cookies.set('expiresIn', in1hour, {
          maxAge: 600,
          domain: store.state.cookieHost,
          path: '/'
        }) // 存储token有效时长
        config.headers.Authorization = `Bearer ${ntoken}`
        onRrefreshed(ntoken)
        config.headers.Authorization = `Bearer ${ntoken}`
        return config
      }
      const retry = new Promise((resolve) => {
        subscribeTokenRefresh((accessToken) => {
          config.headers.Authorization = `Bearer ${accessToken}`
          resolve(config)
        })
      })
      return retry
      // config.headers.Authorization = `Bearer ${ntoken}`
      // return config
    }
  }, errorHandler)

  // 响应拦截
  request.interceptors.response.use((res) => {
    const timer = new Date().getTime() - res.config.headers.metadata.starttime
    let datastr = '未记录'

    let needlog = false
    let statusColum = true
    // const miandata = null
    if (!res || !res.data) {
      needlog = true
      if (res && !res.data) {
        datastr = JSON.stringify(res)
      }
    } else if (res && ((res.status && typeof res.status == 'number' && res.status != 200) || (res.Status && typeof res.Status == 'number' && res.Status != 200))) {
      statusColum = false
    } else if (res && (res.status == false || res.Status == false)) {
      statusColum = false
    } else if (res && ((res.succeed && typeof res.succeed == 'number' && res.succeed != 200) || (res.Succeed && typeof res.Succeed == 'number' && res.Succeed != 200))) {
      statusColum = false
    } else if (res && (res.succeed == false || res.Succeed == false)) {
      statusColum = false
    } else if (res && ((res.success && typeof res.success == 'number' && res.success != 200) || (res.Success && typeof res.Success == 'number' && res.Success != 200))) {
      statusColum = false
    } else if (res && (res.success == false || res.Success == false)) {
      statusColum = false
    }

    if (!statusColum && res) {
      datastr = JSON.stringify(res)
    }

    // if (res && typeof res.data == 'object') {
    //   miandata = res.data
    //   if (res && res.data && typeof res.data.data == 'object') {
    //     miandata = res.data.data
    //   } else if (res && res.data && typeof res.data.result == 'object') {
    //     miandata = res.data.result
    //   }
    // } else if (res && typeof res.result == 'object') {
    //   miandata = res.result
    //   if (res && res.result && typeof res.result.result == 'object') {
    //     miandata = res.result
    //   } else if (res && res.result && typeof res.result.data == 'object') {
    //     miandata = res.data
    //   }
    // }

    let fnc = ''
    // if (!statusColum || (!miandata || miandata == {} || miandata == [] || miandata == '')) {
    if (!statusColum) {
      needlog = true
      fnc = '接口数据异常'
      datastr = res ? JSON.stringify(res.data) : ''
      // 排除不需要记录返回空值的请求
      const passEmpty = ['/homefuc/friendlink-v1', '/homefuc/partnetlist-v1']
      passEmpty.forEach((iturl) => {
        if (res.config && res.config.url.includes(iturl)) {
          needlog = false
        }
      })
    } else if (timer >= 1000 && process.env.NODE_ENV == 'production') {
      needlog = true
      fnc = 'axios耗时'
    }

    if (timer >= 1000 && process.env.NODE_ENV == 'production') {
      needlog = true
      fnc = 'axios耗时'
    }

    let headers = ''
    if (res.config && res.config.headers) {
      headers = JSON.stringify(res.config.headers)
    }
    headers = decodeURIComponent(headers)

    if (needlog && process.env.NODE_ENV == 'production') {
      let canshu = res.config.params ? res.config.params : null
      if (!canshu && res.config && res.config.method && res.config.method.toLowerCase() == 'post' && res.config.data) {
        canshu = res.config.data
      }

      // 处理base64
      if (canshu && typeof canshu == 'object') {
        if (canshu.base64) {
          canshu.base64 = '图片base64格式内容(被替换)'
        } else if (canshu && canshu.images && canshu.images.length > 0 && canshu.images[0] && canshu.images[0].base64) {
          canshu.images.forEach((el) => {
            el.base64 = '图片base64格式内容(被替换)'
          })
        }
        try {
          canshu = JSON.stringify(canshu)
        } catch (e) {}
      } else if (canshu && typeof canshu == 'string' && canshu.includes('base64') && canshu.includes('ext') && canshu.includes('{') && canshu.includes('}')) {
        try {
          const cs = JSON.parse(canshu)
          if (cs && typeof cs == 'object') {
            if (cs.base64) {
              cs.base64 = '图片base64格式内容(被替换)'
            } else if (cs.images && cs.images.length > 0 && cs.images[0] && cs.images[0].base64) {
              cs.images.forEach((el) => {
                el.base64 = '图片base64格式内容(被替换)'
              })
            }
            canshu = JSON.stringify(cs)
          }
        } catch (e) {}
      }

      const param = {
        url: res.config.url, // 请求地址
        method: res.config.method, // 请求方式
        statusCode: res.status, // 请求状态
        params: canshu, // 请求参数
        timer, // 请求时间
        level: 'warn', // 报错等级info-严重；warn-警告
        type: 'url', // url接口-asyncData-asyncData js报错
        message: '', // 报错内容
        CountryCode: res.config.headers.CountryCode, // header国家
        LanguageCode: res.config.headers.LanguageCode, // headers语言
        BasicData: res.config.headers.BasicData, // header---BasicData
        requestid: res.headers['wikidatacenter-request-id'], // 唯一标识id
        time: new Date()
      }
      console.log(param, 8887)

      if ($winstonLog) {
        const mttime = dayjs()
        const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.SSS')} WARN [DATA-API-WEB]:{"Function":"${fnc}(服务端)","Url":"${res.config.url}","PageUrl":"${store.state.allHost}","HttpType":"${res.config.method}","HttpState":${res.status},"Time":${timer},"Parameter":${canshu},"Message":${fnc != 'axios耗时' ? fnc : '接口慢'},"headers":${headers},"info":"${JSON.stringify(param)}","接口返回":"${datastr}","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
        $winstonLog.info(msg)
      } else {
        try {
          const mttime = dayjs()
          const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.SSS')} WARN [DATA-API-WEB]:{"Function":"${fnc}(客户端)","Url":"${res.config.url}","PageUrl":"${store.state.allHost}","HttpType":"${res.config.method}","HttpState":${res.status},"Time":${timer},"Parameter":${canshu},"Message":${fnc != 'axios耗时' ? fnc : '接口慢'},"headers":${headers},"接口返回":"${datastr}","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
          this.$fxlog(msg, res.config.url, res.config.headers.LanguageCode, '1')
        } catch (err) {}
      }
    }

    if (res.config.url.includes('/wikifxweb-v1/wikifx/headermenu/init-v1')) {
      // console.log(res.data.data, 888, res.config.headers)
      store.commit('settestdata', {
        menu: res && res.data && res.data.data,
        head: res.config && res.config.headers
      })
    }

    // if (res.config.url.includes('/wikifxweb-v1/dealer/detail/data/history-v1')) {
    //   console.log(res, 7777)
    // }

    const wikifxweb = res.config.url.includes('wikifxweb')
    const { succeed = true, ErrorCode = 200, Data = '', data = '', message = '' } = res.data
    // console.log(999, res.data)
    // if (res.config.url.includes('/comment/index/list-v1')) {
    //   console.log(res.data, 777)
    // }

    // 发布集市接口返回完整对象
    let needFull = false
    if (wikifxweb && res && res.config && res.config.url) {
      needReturnFullResult.forEach((item) => {
        if (item && item.includes(item)) {
          needFull = true
        }
      })
    }
    // if (process.server) console.log(res.config.url, 444)
    // (wikifxweb && res && res.config && res.config.url && res.config.url.includes('/wikifxweb-v1/market/') && res.config.url.includes('/add'))
    let returnObj = null
    if (ErrorCode != 200 || !succeed) {
      returnObj = process.client ? (needFull ? res.data : res.data.data || res.data) : null // 数据返回不正常，客户端请求的接口返回错误数据，服务端请求的接口进入错误页面
    } else {
      returnObj = Data || data || wikifxweb ? Promise.resolve(Data || data) : res.data // 两者只要有一个字段存在数据，就返回数据
    }

    if (returnObj && needFull) {
      returnObj.message = message
    }
    // 设置缓存
    if (process.server) {
      setApiCache(ssrContext.$cache, res.config, returnObj)
    }
    return returnObj
  }, errorHandler)

  // 模块接口注入
  const apiObj = {}
  if (apiConfig) {
    for (const i in apiConfig) {
      apiObj[i] = apiConfig[i](request)
    }
  }
  inject('api', apiObj)
}
